// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ninput[type='text'][data-v-bba40f12] {\n  border: none;\n  box-shadow: initial;\n  text-align: left;\n  /* font: initial; */\n  font-size: 11px;\n  /* letter-spacing: 2.16px; */\n  color: #3f4a56;\n  background: rgba(255,255,255,.0)\n}\ninput[type='text'][data-v-bba40f12]:focus {\n  box-shadow: initial;\n  outline: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
